import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";
import { venueDashboardPath } from "../lib/venueAccess";
import logo from "../assets/tiply_logo_v5.png";

export default function SelectVenuePage() {
    const {
        currentUser,
        rawUserData,
        venueOptions,
        selectVenue,
        authError,
        loading,
        logout,
    } = useAuth();
    const navigate = useNavigate();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-[#f6f6f9]">
                <div className="h-8 w-8 border-[3px] border-gray-300 border-t-[#0d7c5f] rounded-full animate-spin" />
            </div>
        );
    }

    if (!currentUser) return <Navigate to="/login" replace />;
    if (rawUserData?.role === "ADMIN") return <Navigate to="/admin" replace />;
    if (!rawUserData) return <Navigate to="/signup" replace />;

    const handleSelect = (businessID) => {
        const selectedVenue = selectVenue(businessID);
        if (selectedVenue) navigate(venueDashboardPath(selectedVenue.role), {replace: true});
    };

    return (
        <div className="min-h-screen bg-[#f6f6f9] px-4 py-12 flex items-center justify-center">
            <div className="w-full max-w-xl rounded-2xl border border-gray-200 bg-white p-6 sm:p-8 shadow-sm">
                <img src={logo} alt="Tiply" className="w-32 h-auto mx-auto" />
                <div className="text-center mt-8 mb-6">
                    <h1 className="text-2xl font-bold text-gray-900">Choose a venue</h1>
                    <p className="text-sm text-gray-500 mt-2">
                        Select the venue whose dashboard you would like to open.
                    </p>
                </div>

                {authError && (
                    <p className="mb-4 rounded-lg bg-red-50 px-4 py-3 text-sm text-red-700">{authError}</p>
                )}

                {venueOptions.length > 0 ? (
                    <div className="space-y-3">
                        {venueOptions.map((venue) => (
                            <button
                                key={venue.businessID}
                                type="button"
                                onClick={() => handleSelect(venue.businessID)}
                                className="w-full rounded-xl border border-gray-200 px-4 py-4 text-left hover:border-[#0d7c5f] hover:bg-[#e8f5f0] transition"
                            >
                                <span className="block text-base font-semibold text-gray-900">{venue.businessName}</span>
                                <span className="mt-1 block text-xs font-medium uppercase tracking-wide text-gray-500">
                                    {venue.role === "OWNER" ? "Business account" : "Employee account"}
                                </span>
                            </button>
                        ))}
                    </div>
                ) : (
                    <p className="rounded-lg bg-amber-50 px-4 py-3 text-sm text-amber-800">
                        No valid venue access is configured for this account. Please contact Tiply support.
                    </p>
                )}

                <button
                    type="button"
                    onClick={logout}
                    className="mt-6 w-full text-sm font-medium text-gray-500 hover:text-gray-900"
                >
                    Log out
                </button>
            </div>
        </div>
    );
}
